import { Component, Injector, Input, Optional } from '@angular/core';

import { ProjectregelService } from 'src/app/core/service/projectregel.service';
import { Projectregel } from 'src/app/core/dto/projectregel';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Project } from 'src/app/core/dto/project';
import { InstrumentBarcodeComponent, InstrumentBarcodeDialogData } from '../InstrumentBarcode/instrumentbarcode.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Relatie } from 'src/app/core/dto/relatie';
import { Regelstatus } from 'src/app/core/enums/regelstatus';
import { Instrument } from 'src/app/core/dto/instrument';

@Component({
    selector: 'c-i-j-borculo-projectregel-collection',
    templateUrl: './projectregel-collection.component.html'/*,
    styleUrls: ['./projectregel-collection.component.css'] */
})
export class ProjectregelCollectionComponent extends PagedCollectionComponent<Projectregel> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Projectregel>([
        { colDef: 'barcode', prop: x => x.instrument.nr_Barcode, searchable: SearchableType.String },
        { colDef: 'soort', prop: x => x.instrument.soort, searchable: SearchableType.String },
        { colDef: 'merk', prop: x => x.instrument.merk, searchable: SearchableType.String },
        { colDef: 'type', prop: x => x.instrument.type, searchable: SearchableType.String },
        { colDef: 'status', prop: x => x.status, searchable: { type: SearchableType.Enum, enum: Regelstatus } },
        { colDef: 'certificaat', prop: x => x.certificaat, searchable: SearchableType.String },
        { colDef: 'datumPublicatie', prop: x => x.datumPublicatie, searchable: SearchableType.Date }

    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ProjectregelService, @Optional() protected filter: Filter<Projectregel>, injector: Injector, private dialog: MatDialog) {
        super('/projectregel/projectregel', injector, Projectregel);

        this.initInput('project', this.filterBuilder.equal(x => x.project.id));
        this.initInput('relatie', this.filterBuilder.equal(x => x.project.relatie.id));
        this.initInput('instrument', this.filterBuilder.equal(x => x.instrument.id));

        this.orderBy=[-7];
        
		this.filter.onGetChipLabel(x => x.instrument.nr_Barcode, () => 'Barcode');
        this.filter.onGetChipLabel(x => x.instrument.soort, () => 'Soort');
		this.filter.onGetChipLabel(x => x.instrument.merk, () => 'Merk');
        this.filter.onGetChipLabel(x => x.instrument.type, () => 'Type');
		this.filter.onGetChipLabel(x => x.status, () => 'Status');		
        this.filter.onGetChipLabel(x => x.certificaat, () => 'Certificaat');
		this.filter.onGetChipLabel(x => x.datumPublicatie, () => 'Datum Publicatie');
    }

    ngOnInit() {
        super.ngOnInit();
        this.setCustomActions();
    }

    private _project: Project;
    private _relatie: Relatie;
    private _instrument: Instrument;

    @Input() set project(val: Project) {
        this.handleInput('project', val.id);
        this._project = val;
    }
    
    @Input() set relatie(val: Relatie) {
        this.handleInput('relatie', val.id);
        this._relatie = val;
    }

    @Input() set instrument(val: Instrument) {
        this.handleInput('instrument', val.id);
        this._instrument = val;
    }

    setCustomActions() {
        this.buildCustomActions(config => config.add({
            icon: "horizontal_split",
            name: "Barcode",
            pin: true,
            fn: () => this.InstrumentByBarcode(), 
            show:(this._instrument==null),          
            isEnabled: this.authScheme.canDo("CIJBorculo.Logic.Requests.InstrumentBarcodeRequest") && this.authScheme.canDo("CIJBorculo.Logic.Requests.SetBarcodeRequest")
        }))
    }

    InstrumentByBarcode() {
        
        const dialogConfig = new MatDialogConfig<InstrumentBarcodeDialogData>();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "500px";
        dialogConfig.data = { project: this._project, relatie: this._relatie }
        
        this.dialog.open(InstrumentBarcodeComponent, dialogConfig).afterClosed()
            .subscribe(response =>  {
                // opnieuw openen (indien ok), want barcode scannen gaat in batches
                if (response.data == 'ok'){                    
                    this.dataSource.update();
                    this.InstrumentByBarcode();
                }
            }
        );

        
    }

    getStatus(value) {

		switch (Number(value)) {
			case Regelstatus.Afkeur:
				return "Afkeur";
			case Regelstatus.Gereed:
				return "Gereed";
			case Regelstatus.Justeren:
				return "Justeren";
			case Regelstatus.Kalibratie:
				return "Kalibratie";
            case Regelstatus.Nieuw:
                return "Nieuw";
            case Regelstatus.Publiceren:
                return "Publiceren";
            case Regelstatus.Reparatie:
                return "Reparatie";
            case Regelstatus.Uitbesteed_Akkoord:
                return "Uitbesteed Akkoord";
            case Regelstatus.Uitbesteed:
                return "Uitbesteed";
            //case Regelstatus.Validatie:
            //    return "Validatie";
            case Regelstatus.Verwerkt:
                return "Verwerkt";                
            case Regelstatus.Werkbon:
                return "Werkbon";                
            case Regelstatus.Afgehandeld:
                    return "Afgehandeld";                
    
			default:
				return value;
		}
	}

}